const roundToAtMost2Decimals = num => {
    const m = Number((Math.abs(num) * 100).toPrecision(15));
    return Math.round(m) / 100 * Math.sign(num);
};

const calculatePickupTotalCost = pickupCostData => {
    let totalCost = 0;
    const {additionalCost, calculatedPickupPrice, toggleSpecialPickupPrice, specialPickupPrice} = pickupCostData;
    if (additionalCost) totalCost += parseFloat(additionalCost);
    if (toggleSpecialPickupPrice && specialPickupPrice) {
        totalCost += (typeof specialPickupPrice === 'number')
            ? specialPickupPrice : parseFloat(specialPickupPrice);
        return roundToAtMost2Decimals(totalCost);
    }
    if (calculatedPickupPrice) {
        totalCost += (typeof calculatedPickupPrice === 'number')
            ? calculatedPickupPrice : parseFloat(calculatedPickupPrice);
    }

    return roundToAtMost2Decimals(totalCost);
};

export default calculatePickupTotalCost;
